import { useNavigate, useParams } from "react-router-dom";

function withNavigation(Component: any) {
  return (props: any) => <Component {...props} navigate={useNavigate()} params= {useParams()} />;
}

export default withNavigation;